module.exports = __webpack_public_path__ + "img/canada-crime-index-1.9f815dd3.jpg";